module.exports = __webpack_public_path__ + "static/media/alexdocas2.3d86e6c6.jpg";